// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Vw","ring":"i_Vx","circle":"i_Vy","progress":"i_Vz","lower-progress":"i_V0","content":"i_V1","children":"i_V2","marker":"i_V3","lower-marker":"i_V4"};